import { IconButton, Menu, MenuItem, Typography } from '@mui/material'
import FormatSizeIcon from '@mui/icons-material/FormatSize'
import { Editor } from '@tiptap/core'

const FontSizeMenu = ({
  editor,
  fontSizes,
  fontSizeAnchor,
  setFontSizeAnchor,
  openFontMenu,
  forceExpand,
  setFloatingOpen,
  container,
}: {
  editor: Editor
  fontSizes: string[]
  fontSizeAnchor: null | HTMLElement
  setFontSizeAnchor: React.Dispatch<React.SetStateAction<null | HTMLElement>>
  openFontMenu: (el: HTMLElement) => void
  forceExpand: () => void
  setFloatingOpen: (v: boolean) => void
  container?: HTMLElement | null
}) => {
  const open = Boolean(fontSizeAnchor)

  const handleClose = () => {
    setFontSizeAnchor(null)
    setFloatingOpen(false)
    // put caret back in editor so wrapper stays expanded
    editor?.chain().focus().run()
  }

  return (
    <>
      <IconButton
        size="small"
        onMouseDown={e => {
          e.preventDefault() // don’t move focus off the editor
        }}
        onMouseUp={e => {
          e.preventDefault()
          e.stopPropagation()
          openFontMenu(e.currentTarget) // sets anchor + floatingOpen
        }}
        sx={{ borderRadius: 0 }}
      >
        <FormatSizeIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={fontSizeAnchor}
        open={open}
        onClose={handleClose}
        // keep the Menu inside the wrapper to satisfy :focus-within
        container={container ?? undefined}
        disablePortal={!!container} // render in-place when container is provided
        // don’t steal focus from the editor
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
        MenuListProps={{ autoFocusItem: false }}
      >
        {fontSizes.map(size => (
          <MenuItem
            key={size}
            onClick={() => {
              editor?.chain().focus().setFontSize(size).run()
              handleClose()
            }}
            selected={editor?.isActive('textStyle', { fontSize: size })}
          >
            <Typography sx={{ fontSize: size }}>{size}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default FontSizeMenu
